import canvg from 'canvg'

class ChartUtil {
  getChartImage (chart) {
    if (chart === undefined) {
      return null
    }
    const EXPORT_WIDTH = 1000
    const RENDER_WIDTH = EXPORT_WIDTH
    const RENDER_HEIGHT = RENDER_WIDTH * chart.chartHeight / chart.chartWidth

    const svg = chart.getSVG({
      exporting: {
        sourceWidth: chart.chartWidth,
        sourceHeight: chart.chartHeight
      }
    })

    let canvas = document.createElement('canvas')
    canvas.height = RENDER_HEIGHT
    canvas.width = RENDER_WIDTH

    canvg(canvas, svg, {
      scaleWidth: RENDER_WIDTH,
      scaleHeight: RENDER_HEIGHT,
      ignoreDimensions: true
    })

    return canvas.toDataURL('image/png')
  }
}

export default new ChartUtil()
